<template>
  <div class="input-container">
    <table>
      <tr>
        <td>
          <img v-bind:src="field.image" class="icon" />
        </td>
      </tr>
      <tr>
        <td>
          <input
            type="text"
            maxlength="1"
            name="input"
            v-model="field.value"
            placeholder="_"
            @keyup="$emit('update', field.value)"
            :disabled="field.disabled"
          />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "CustomInput",
  props: { input: Object },
  data() {
    return {
      field: this.input,
      url: "@/assets/Escape/letters/1.jpeg",
    };
  },
  methods: {
    toggle() {
      this.$emit("toggleNote");
    },
  },
};
</script>

<style scoped>
input-container {
  width: 8px;
}
input {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  font-weight: bold;
  text-align: center;
  line-height: 18px;
  color: rgb(35, 35, 35);
  background: none;
  border: none;
  text-transform: uppercase;
  font-size: 16px;
  background: rgb(230, 230, 230);
}
input:focus {
  outline: none;
}
table {
  border-collapse: collapse;
}
td {
  border: 1px solid black;
  padding: 0px;
  width: 8px;
  height: 15px;
  background: white;
}
img {
  max-height: 50px;
  max-width: 31px;
  height: auto;
  width: auto;
}
td .icon {
  min-height: 50px;
  min-width: 31px;
  padding: 2px;
}
</style>
